export default __webpack_public_path__ + "static/register-backgrounds-1f06ed2d3826c1e4625f5647aef2e580.jpg";